import React from 'react';
import { Tab, Tabs, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  tabSelected: {
    background: '#622FEE',
    color: '#FEFEFE',
  },
  textColorPrimary: {
    color: '#622FEE',
  },
  whiteText: {
    color: '#FEFEFE',
    maxHeight: '10px',
  },
  purpleText: {
    color: '#622FEE',
    maxHeight: '10px',
  },
  tabs: {
    width: '100%',
    border: '1px solid #622FEE',
    borderRadius: '4px',
  },
}));

export function TabNativeContent({ setTabValue, tabValue, tabs = [], tabWidth = '50%' }) {
  return (
    <div>
      <Tabs
        value={tabValue}
        onChange={(event, newValue) => setTabValue(newValue)}
        aria-label="simple tabs example"
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map((tabItem) => (
          <Tab
            key={tabItem.index}
            label={tabItem.label}
            style={{ minWidth: tabWidth, fontWeight: '600', padding: '0px', marginLeft: '12px' }}
          />
        ))}
      </Tabs>
    </div>
  );
}

export function TabStyledContent({ tabValue, setTabValue, tabs = [] }) {
  const classes = useStyles();

  return (
    <Tabs
      value={tabValue}
      onChange={(event, newValue) => setTabValue(newValue)}
      indicatorColor="primary"
      textColor="primary"
      className={classes.tabs}
    >
      {tabs.map((tabItem) => (
        <Tab
          key={tabItem.index}
          classes={{
            wrapper: tabValue === tabItem.index ? classes.whiteText : classes.purpleText,
            selected: classes.tabSelected,
            textColorPrimary: classes.textColorPrimary,
          }}
          label={tabItem.label}
          style={{ minWidth: tabs.length === 1 ? '100%' : '50%' }}
        />
      ))}
    </Tabs>
  );
}
